import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Storage } from 'aws-amplify';
import { useNavigate } from 'react-router';
import { ulid } from 'ulid';
import { Loading, Layout, UserNavbar } from '../../../components';
import * as VenueActions from '../../../core/venues/action';
import Banner from './components/Banner/Banner';
import { AddVenue } from './components';
import './styles.scss';

export default function Venues() {
  const [title] = useState('Manage Venue');
  const [loadingUpload, setLoadingUpload] = useState(false);
  const {
    venues: { loading, venuePictures, features, banner, pictures },
    users: { user },
  } = useSelector((store) => store);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uploadPictures = useCallback(
    async (pics) => {
      const fileUploaded = [];
      try {
        setLoadingUpload(true);
        await Promise.all(
          pics.map(async ({ file }) => {
            const fileName = `${ulid()}.${file.name.split('.')[1]}`;
            const ready = await Storage.put(`VENUES/${user.id}/${fileName}`, file, {
              contentType: file.type,
            });
            fileUploaded.push({ ...ready, fileName });
          }),
        );
      } catch (error) {
        console.error('Error uploading file: ', error);
      }
      return fileUploaded;
    },
    [user?.id],
  );

  const onSaveVenue = async (venue, activatedFeatures, isEdit) => {
    const fileUploaded = await uploadPictures(venuePictures);
    setLoadingUpload(false);
    if (isEdit) {
      const socialNetworks = [];
      if (venue.facebook && venue.facebook.trim() !== '') {
        const sn = venue?.social_network?.find((social) => social.name === 'Facebook');
        console.log('🚀 ~ file: index.jsx:53 ~ onSaveVenue ~ sn:', sn);
        if (sn !== undefined) {
          sn.url = venue.facebook;
          socialNetworks.push(sn);
        } else {
          socialNetworks.push({ name: 'Facebook', url: venue.facebook });
        }
      }
      if (venue.twitter && venue.twitter.trim() !== '') {
        const sn = venue?.social_network?.find((social) => social.name === 'Twitter');
        if (sn !== undefined) {
          sn.url = venue.twitter;
          socialNetworks.push(sn);
        } else {
          socialNetworks.push({ name: 'Twitter', url: venue.twitter });
        }
      }
      if (venue.instagram && venue.instagram.trim() !== '') {
        const sn = venue?.social_network?.find((social) => social.name === 'Instagram');
        if (sn !== undefined) {
          sn.url = venue.instagram;
          socialNetworks.push(sn);
        } else {
          socialNetworks.push({ name: 'Instagram', url: venue.instagram });
        }
      }
      dispatch(
        VenueActions.updateVenue(
          {
            ...venue,
            fk_user: user.id,
            features: activatedFeatures,
            pictures: fileUploaded,
            social_network: socialNetworks,
          },
          navigate,
        ),
      );
    } else {
      const socialNetworks = [];
      if (venue.facebook && venue.facebook.trim() !== '')
        socialNetworks.push({ name: 'Facebook', url: venue.facebook });
      if (venue.twitter && venue.twitter.trim() !== '')
        socialNetworks.push({ name: 'Twitter', url: venue.twitter });
      if (venue.instagram && venue.instagram.trim() !== '')
        socialNetworks.push({ name: 'Instagram', url: venue.instagram });
      dispatch(
        VenueActions.createVenue(
          {
            venue: { ...venue, fk_user: user.id },
            features: activatedFeatures,
            pictures: fileUploaded,
            socialNetworks,
          },
          navigate,
        ),
      );
    }
  };

  useEffect(() => {
    if (features?.length === 0) dispatch(VenueActions.getVenueFeatures());
  }, [dispatch, features]);

  return (
    <Layout>
      {(loading || loadingUpload) && <Loading />}
      <UserNavbar />
      <Banner picture={banner} />
      <Grid container justifyContent="space-evenly">
        <Typography variant="h4" color="#EE7B57" fontWeight="bold" marginTop={4}>
          {title}
        </Typography>
      </Grid>
      <AddVenue onSaveVenue={onSaveVenue} />
    </Layout>
  );
}
